import React from "react";
import ReactDOM from "react-dom";
import { Grid } from "@material-ui/core";
import EmployeeDetailRequestList from "./index";

export default function renderEmployeeDetailRequestList({
  target = "employee-detail-requests",
  wrapped = false,
  ...rest
}) {
  const domTarget = document.getElementById(
    wrapped ? "page-container" : target
  );
  if (domTarget) {
    if (wrapped) {
      ReactDOM.render(
        <Grid className="section employee-details-page" container>
          <EmployeeDetailRequestList {...rest} />
        </Grid>,
        domTarget
      );
    } else {
      ReactDOM.render(<EmployeeDetailRequestList {...rest} />, domTarget);
    }
  }
}
